import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6fd06e38"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ws_drawer_footer" }

import { ref, watch } from 'vue'
import { isEmpty } from 'lodash'
import {
  deviceBindCardInfoAdd,
  deviceBindCardInfoUpdate,
  querySingleDeviceList,
  querySatelliteTreeList,
} from '@/api'
import { CODE_ENUM } from '@/common'
import { ElMessage } from 'element-plus'


export default /*#__PURE__*/_defineComponent({
  __name: 'card-form',
  props: ['visible', 'data'],
  emits: ['update:visible', 'on-success'],
  setup(__props, { emit: __emit }) {

const props = __props
const $emit = __emit

const mapRef = ref()
const formRef = ref()

const formData: any = ref({
  cardNo: '',
  deviceSn: undefined,
  satelliteCodeList: [],
})

watch(
  () => props.visible,
  () => {
    if (props.visible) {
      if (!isEmpty(props.data)) {
        const { cardNo, deviceSn, satelliteCode = '' } = props.data

        const satelliteCodeList = satelliteCode.split(',').filter(Boolean)
        formData.value = {
          cardNo,
          deviceSn,
          satelliteCodeList,
        }
      }
    }
  }
)

const rules: any = {
  cardNo: [{ required: true, message: '请输入' }],
  deviceSn: [{ required: true, message: '请输入' }],
  // satelliteCodeList: [{ required: true, message: '请选择', type: 'array' }],
}

const submit = () => {
  formRef.value.validate((valid: boolean) => {
    if (valid) {
      handleAPI()
    }
  })
}

const loading = ref(false)
const handleAPI = async () => {
  loading.value = true

  const { satelliteCodeList, cardNo, deviceSn } = formData.value
  const satelliteCode = satelliteCodeList.join(',')
  const fn = props.data.id ? deviceBindCardInfoUpdate : deviceBindCardInfoAdd
  const res: any = await fn({
    cardNo,
    deviceSn,
    satelliteCode,
    id: props.data?.id,
  }).finally(() => {
    loading.value = false
  })
  if (res.code === CODE_ENUM.SUCCESS) {
    ElMessage.success(res?.msg)
    $emit('on-success')
    handleClose()
  }
}

const singleDeviceList: any = ref([])
const queryDeviceList = async () => {
  const res: any = await querySingleDeviceList()
  if (res?.code === CODE_ENUM.SUCCESS) {
    singleDeviceList.value = (res.data || []).map(({ deviceSn }: any) => {
      return {
        label: deviceSn,
        value: deviceSn,
      }
    })
  }
}
queryDeviceList()
const handleClose = () => {
  $emit('update:visible', false)
  formRef.value?.resetFields?.()
}

const satelliteList: any = ref([])
const querySatelliteList = async () => {
  const res: any = await querySatelliteTreeList()
  if (res?.code === CODE_ENUM.SUCCESS) {
    satelliteList.value = res.data || []
  }
}

querySatelliteList()

const checkAll = ref(false)
const indeterminate = ref(false)

watch(
  () => formData.value.satelliteCodeList,
  (val) => {
    if (val.length === 0) {
      checkAll.value = false
      indeterminate.value = false
    } else if (val.length === satelliteList.value.length) {
      checkAll.value = true
      indeterminate.value = false
    } else {
      indeterminate.value = true
    }
  },
  {
    deep: true,
  }
)

const handleCheckAll = (val: any) => {
  indeterminate.value = false
  if (val) {
    formData.value.satelliteCodeList = satelliteList.value.map(
      (_: any) => _.satelliteCode
    )
  } else {
    formData.value.satelliteCodeList = []
  }
}

return (_ctx: any,_cache: any) => {
  const _component_el_select_v2 = _resolveComponent("el-select-v2")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_drawer = _resolveComponent("el-drawer")!

  return (_openBlock(), _createBlock(_component_el_drawer, {
    "model-value": props.visible,
    "destroy-on-close": "",
    title: props.data.id ? '编辑卡号' : '添加卡号',
    size: "480",
    "before-close": handleClose,
    "label-position": "left"
  }, {
    footer: _withCtx(() => [
      _createElementVNode("span", _hoisted_1, [
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: submit,
          loading: loading.value
        }, {
          default: _withCtx(() => [
            _createTextVNode(" 确定 ")
          ]),
          _: 1
        }, 8, ["loading"]),
        _createVNode(_component_el_button, {
          onClick: handleClose,
          plain: ""
        }, {
          default: _withCtx(() => [
            _createTextVNode(" 取消 ")
          ]),
          _: 1
        })
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_el_form, {
        ref_key: "formRef",
        ref: formRef,
        model: formData.value,
        rules: rules,
        class: "form ws_common_form",
        "label-width": 80
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, {
            label: "设备SN",
            prop: "deviceSn"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select_v2, {
                modelValue: formData.value.deviceSn,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.deviceSn) = $event)),
                options: singleDeviceList.value,
                filterable: "",
                class: "ws_select"
              }, null, 8, ["modelValue", "options"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "IMEI号",
            prop: "cardNo"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: formData.value.cardNo,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.cardNo) = $event)),
                clearable: "",
                maxlength: "50",
                placeholder: "请输入IMEI号"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "卫星ID",
            prop: "satelliteCodeList"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                modelValue: formData.value.satelliteCodeList,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.value.satelliteCodeList) = $event)),
                class: "ws_select",
                filterable: "",
                multiple: "",
                "collapse-tags": "",
                "collapse-tags-tooltip": ""
              }, {
                header: _withCtx(() => [
                  _createVNode(_component_el_checkbox, {
                    modelValue: checkAll.value,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((checkAll).value = $event)),
                    indeterminate: indeterminate.value,
                    onChange: handleCheckAll
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" 全选 ")
                    ]),
                    _: 1
                  }, 8, ["modelValue", "indeterminate"])
                ]),
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(satelliteList.value, (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: item.satelliteCode,
                      label: item.satelliteName + ' (' + item.satelliteCode + '）',
                      value: item.satelliteCode
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model"])
    ]),
    _: 1
  }, 8, ["model-value", "title"]))
}
}

})